import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import clsx from 'clsx'
import { CardListRefactor } from '.'
import useStyles from './styles'

export const BoardColumn = React.memo((props) => {
  const { name, summary, renderFooter, count, cardFields, renderCardItem, loadMoreData, skeleton, ...listProps } = props

  const classes = useStyles()
  const itemListRef = useRef([])

  const [isFetchingLoadMore, setIsFetchingLoadMore] = useState(false)

  let isFetching = useMemo(() => Boolean(skeleton), [skeleton])

  useEffect(() => {
    if (!isFetching) setIsFetchingLoadMore(false)
  }, [isFetching])

  /** new handleOnScroll */
  const handleOnScroll = useCallback((e) => {
    if (!loadMoreData || isFetching) return

    const { scrollTop, scrollHeight, clientHeight } = e.target
    const scrollBottom = Math.floor(scrollHeight - scrollTop)
    
    // Check if near bottom (within 1px tolerance)
    if (scrollBottom <= clientHeight + 1) {
      loadMoreData()
      setIsFetchingLoadMore(true)
    }
  }, [isFetching, loadMoreData])

  /** old, legacy handleOnScroll */
  // const handleOnScroll = useCallback((e) => {
  //   let load = false
  //   let topFirstPage = 0

  //   if (!isFetching && itemListRef.current.length > 0) {
  //     let firstDataPage = listProps?.items?.[listProps?.items?.length - 20]
  //     let carditem = itemListRef.current[listProps?.items?.length - 20]?.getBoundingClientRect()
  //     topFirstPage = carditem?.top || 0
  //   }

  //   if (!load && !isFetching && topFirstPage < 0) {
  //     load = true
  //   } else if (Math.floor(Math.floor(e.target.scrollHeight) - Math.floor(e.target.scrollTop)) === Math.floor(e.target.clientHeight)) {
  //     // bottom
  //     load = true
  //   } else if (Math.floor(Math.floor(e.target.scrollHeight) - Math.floor(e.target.scrollTop)) === Math.floor(e.target.clientHeight) + 1) {
  //     // bottom
  //     load = true
  //   }

  //   if (load && loadMoreData) {
  //     loadMoreData()
  //     setIsFetchingLoadMore(true)
  //   }
  // }, [isFetching, loadMoreData, listProps?.items])

  return (
    <div className={clsx(classes.boardColumn)}>
      <div className={classes.boardColumnHeader}>
        {name}
      </div>
      {
        summary &&
        <div className={classes.boardColumnSummary}>
          {summary}
        </div>
      }
      <CardListRefactor
        variant="card"
        {...listProps}
        skeleton={(isFetching && !isFetchingLoadMore) ? skeleton : undefined}
        onScroll={handleOnScroll}
        className={clsx(!renderFooter && classes.boardColumnWrapCard, renderFooter && classes.boardColumnWrapCardWithFooter)}
        fields={cardFields}
        renderCardItem={renderCardItem}
        itemListRef={itemListRef}
      />
      {
        renderFooter &&
        <div className={classes.boardColumnFooter}>
          {renderFooter}
        </div>
      }
    </div>
  )
}, (prev, next) => {
  return (
    prev.items === next.items &&
    prev.skeleton === next.skeleton &&
    prev.cardFields === next.cardFields &&
    prev.name === next.name &&
    prev.summary === next.summary
  )
})

export default React.memo(BoardColumn)